import React from 'react';
import MediaQuery from 'react-responsive'
import './Home4-2.scss'

const Home4 = ({sectionCurrently, positionCurrently, Section, Position, responsive}) => {

    const scroll = () =>{
        return sectionCurrently === Section.Section4 &&
                (positionCurrently === Position.TOP ||
                positionCurrently === Position.BOTTOM) &&
                !responsive
    }


    const mx = "fourth-body-section fade-slide-in-animation disposition-column justify-start align-center ";
    const md = "fourth-body-section-md fade-slide-in-animation disposition-column justify-start align-center";
    const mm = "fourth-body-section-m fade-slide-in-animation disposition-column justify-center align-center";

    const text2 = "Get real-time help with account inquiries";
    const text3 = "Manage everything from WhatsApp. Send money to friends or pay bills";

    return (
        <>  
            <MediaQuery minWidth={1300}>
                <div className = { `${mx} ${scroll() ? "fade-out-animation" : ""}`}>
                    <div className = "fourth-body-elements disposition-column justify-center align-center">
                        <div className="first-row disposition-row justify-start align-center">
                            <div className = "description-section fade-slide-in-animation disposition-row justify-start align-center ">
                                <p className = "title-1">24/7<br/><b>WhatsApp Concierge</b></p>
                            </div>
                            <div className = "icons-elements disposition-row justify-between align-center">
                                <div className = "icon-element disposition-row justify-between align-start">
                                    <img src = "assets/Home/Home4-2/icon-1-1.png" className = "icon-img" alt = "icon"></img>
                                    <p className = "text-2">Notification of all your spending and refunds</p>
                                </div>
                                <div className = "icon-element disposition-row justify-between align-start">
                                    <img src = "assets/Home/Home4-2/icon-1-3.png" className = "icon-img" alt = "icon"></img>
                                    <p className = "text-2">{text3}</p>
                                </div>
                                <div className = "icon-element disposition-row justify-between align-start">
                                    <img src = "assets/Home/Home4-2/icon-1-2.png" className = "icon-img" alt = "icon"></img>
                                    <p className = "text-2">{text2}</p>
                                </div>
                                <div className = "icon-element disposition-row justify-between align-start">
                                    <img src = "assets/Home/Home4-2/icon-1-4.png" className = "icon-img" alt = "icon"></img>
                                    <p className = "text-2">Works in any language you prefer</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </MediaQuery>
            <MediaQuery maxWidth={1300} minWidth={1065}>
                <div className = { `${md} ${scroll() ? "fade-out-animation" : ""}`}>
                    <div className = "fourth-body-elements disposition-column justify-center align-center">
                        <div className="first-row disposition-row justify-start align-center">
                            <div className = "description-section fade-slide-in-animation align-center ">
                                <p className = "title-1">24/7<br/><b>WhatsApp Concierge</b></p>
                            </div>
                            <div className = "icons-elements disposition-row justify-between align-center">
                                <div className = "icon-element disposition-row justify-between align-start">
                                    <img src = "assets/Home/Home4-2/icon-1-1.png" className = "icon-img" alt = "icon"></img>
                                    <p className = "text-2">Notification of all your spending and refunds</p>
                                </div>
                                <div className = "icon-element disposition-row justify-between align-start">
                                    <img src = "assets/Home/Home4-2/icon-1-3.png" className = "icon-img" alt = "icon"></img>
                                    <p className = "text-2">{text3}</p>
                                </div>
                                <div className = "icon-element disposition-row justify-between align-start">
                                    <img src = "assets/Home/Home4-2/icon-1-2.png" className = "icon-img" alt = "icon"></img>
                                    <p className = "text-2">{text2}</p>
                                </div>
                                <div className = "icon-element disposition-row justify-between align-start">
                                    <img src = "assets/Home/Home4-2/icon-1-4.png" className = "icon-img" alt = "icon"></img>
                                    <p className = "text-2">Works in any language you prefer</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </MediaQuery>
            <MediaQuery maxWidth={1064.99}>
              <div className = { `${mm} ${scroll() ? "fade-out-animation" : ""}`}>
                  <div className = "fourth-body-elements disposition-column justify-center align-center">
                      <div className="first-row disposition-column justify-start align-center">
                          <div className = "description-section fade-slide-in-animation disposition-column justify-start align-start ">
                              <p className = "title-1">24/7<br/><b>WhatsApp Concierge</b></p>
                          </div>
                          <div className = "camel-section disposition-column justify-start align-center">
                            <img src = "assets/Home/Home4/img-camello.png" className = "camello-img" alt = "Camello"></img>
                            <div className = "icons-elements disposition-row justify-center align-center">
                              <div className = "icon-element disposition-row justify-between align-center">
                                  <img src = "assets/Home/Home4-2/icon-1-1.png" className = "icon-img" alt = "icon"></img>
                                  <p className = "text-2">Notification of all your spending and refunds</p>
                              </div>
                              <MediaQuery maxWidth={750}><hr className = "line"></hr></MediaQuery>
                              <div className = "icon-element disposition-row justify-between align-center">
                                  <img src = "assets/Home/Home4-2/icon-1-3.png" className = "icon-img" alt = "icon"></img>
                                  <p className = "text-2">{text3}</p>
                              </div>
                              <MediaQuery maxWidth={750}><hr className = "line"></hr></MediaQuery>
                              <div className = "icon-element disposition-row justify-between align-center">
                                  <img src = "assets/Home/Home4-2/icon-1-2.png" className = "icon-img" alt = "icon"></img>
                                  <p className = "text-2">{text2}</p>
                              </div>
                              <MediaQuery maxWidth={750}><hr className = "line"></hr></MediaQuery>
                              <div className = "icon-element disposition-row justify-between align-center">
                                  <img src = "assets/Home/Home4-2/icon-1-4.png" className = "icon-img" alt = "icon"></img>
                                  <p className = "text-2">Works in any language you prefer</p>
                              </div>
                            </div>
                          </div>
                          
                      </div>
                  </div>
              </div>
            </MediaQuery>
        </>
    );
};

export default Home4;
